import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiInstance } from "../../api/apiInstance"
import anchor from '../../../constants/anchor'

const getMarketplacesInfo = () => async(
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const params = {
        userId:  userData.smsAuth.userId,
    }
    const config = {
        headers: {
            Authorization: `${anchor} ${localStorage.getItem('accessToken')}`
        }
    }
    dispatch({ type: storeDispatchTypes.setSalesLoader, value: { field: 'marketplacesInfo', value: true } })
    try {
        const { data: { status, data } } = await apiInstance.post('/sales/marketplaces/getMarketplacesInfo', params, config)
        if(status === 'ok') {
            dispatch({
                type: storeDispatchTypes.setMarketplacesInfo,
                value: {
                    info: data
                },
            })
        }
    } catch (e) {
        console.error('set marketPlaces info failed', e)
    }
    dispatch({ type: storeDispatchTypes.setSalesLoader, value: { field: 'marketplacesInfo', value: false } })

}


export default getMarketplacesInfo
